import React from 'react'

export default function Circle() {
  return (
    <div className='w-[864px] h-[864px] rounded-full bg-gradient-radial at-center from-[#F39020] from-15% via-[#F9CA95]/5  to-white'></div>
  )
}
